const _ = require('lodash');
const getCategories = require('../../../olycommon/analytics/dtm/helpers/product-categories.js');

const getPromotionType = function (matchedPromotion) {
    if (matchedPromotion.IsBonusOffer) return 'BonusProduct';
    if (matchedPromotion.IsDeferred) return 'Deferred';
    if (matchedPromotion.IsMultiBuy) return 'MultiBuy';
    if (matchedPromotion.IsPackagePrice) return 'PackagePrice';
    if (matchedPromotion.IsProductGroupPercentageOff) return 'ProductGroupPercentageOff';
    if (matchedPromotion.IsR1Promotion) return 'R1Promotion';
    if (matchedPromotion.IsLegacyProductPromotion) return 'ClassicPromotion';
    return '';
};

module.exports = function (data) {
    const productNode = {
        product: {
            productInfo: {
                productID: data.product.Stockcode,
                productName: data.product.Name,
                price: data.product.Price || data.product.ListPrice,
                variant: data.product.PackageSize,
                description: data.product.Description,
                productURL: data.Url,
                productImage: data.product.LargeImageFile,
                productThumbnail: data.product.SmallImageFile,
            },
            category: {
                primaryCategory: getCategories(data.product.Source).primaryCategory || (data.currentCategory ? data.currentCategory.aisle.Name : undefined),
                subCategory: getCategories(data.product.Source).subCategory || (data.currentCategory ? data.currentCategory.category.Name : undefined),
                productBrand: data.product.Brand,
                sapDepartment: data.product.SapCategories ? data.product.SapCategories.SapDepartmentName : '',
                sapCategory: data.product.SapCategories ? data.product.SapCategories.SapCategoryName : '',
                sapSubCategory: data.product.SapCategories ? data.product.SapCategories.SapSubCategoryName : '',
                sapSegment: data.product.SapCategories ? data.product.SapCategories.SapSegmentName : '',
            },
            attributes: {
                promotionType: data.product.IsBundleProduct ? 'Bundle' : _.reduce(data.product.MatchedPromotions, (result, current) => {
                    const promotionType = getPromotionType(current);

                    // Ensure there is a valid and known promotion type.
                    if (!promotionType) return result;

                    // Avoid appending delimiter on start of reduction.
                    if (result === '') result += promotionType;

                    // Prevent duplicate promotions from being appended.
                    if (_.includes(result, promotionType)) return result;

                    return `${result}:${promotionType}`;
                }, ''),
                outOfStock: !data.product.IsAvailable,
            },
        },
    };

    // These fields are only populated inside cart node as this mapper is shared between Product node and Cart node.
    if (data.Quantity) {
        productNode.product.quantity = data.Quantity;
    }
    if (data.Price) {
        productNode.product.price = data.Price; // This is the total price of all the products of this stockcode i.e. data.Quantity * data.product.Price
    }

    return productNode;
};



// WEBPACK FOOTER //
// ./src/shop/shelfproduct/dtmmapper/product-analytics-mapper.js